import { RemoteData } from '@lycoris-nubila/ngx-lycoris';
import { Observable } from 'rxjs';

import { IUserUsageStats } from 'user/user-usage-stats';

export abstract class AppSharedApplicationPort {
	public abstract observeUserUsageStats(): Observable<
		RemoteData<IUserUsageStats>
	>;

	public abstract observePendingMessages(
		authorsId: string[]
	): Observable<RemoteData<{ [key: string]: number }>>;
}
